module.exports = __webpack_public_path__ + "media/images/logo-fondo-oscuro-cuota-facil-a6f049ac7bb007a1df8b3c8ca60147a4.jpeg";